import React from "react";
import { Helmet } from "react-helmet-async";
import "./Destinations.css";

// Image imports
import p1 from "../../Assets/Jaipur.jpg";
import p2 from "../../Assets/Udaipur, Rajasthan.jpg";
import p3 from "../../Assets/Goa Beaches.jpg";
import p4 from "../../Assets/Shimla.jpg";
import p5 from "../../Assets/Ladakh.jpg";
import p6 from "../../Assets/Varanasi, Uttar Pradesh.jpg";
import p7 from "../../Assets/aayodha.jpg";
import p8 from "../../Assets/Mumbai, Maharashtra.jpg";
import p9 from "../../Assets/Pune, Maharashtra.jpg";
import p10 from "../../Assets/Bangalore, Karnataka.jpg";
import p11 from "../../Assets/Coorg, Karnataka.jpg";
import p12 from "../../Assets/Chennai, Tamil Nadu.jpg";
import p13 from "../../Assets/Ooty, Tamil Nadu.jpg";
import p14 from "../../Assets/Hyderabad, Telangana.png";
import p15 from "../../Assets/Kolkata, West Bengal.jpg";
import p16 from "../../Assets/Darjeeling, West Bengal.jpg";
import p17 from "../../Assets/Kochi, Kerala.jpg";
import p18 from "../../Assets/Munnar, Kerala.jpg";
import p19 from "../../Assets/Ahmedabad, Gujarat.jpg";
import p20 from "../../Assets/Dwarka, Gujarat.jpg";
import p21 from "../../Assets/Bhopal, Madhya Pradesh.jpg";
import p22 from "../../Assets/Khajuraho, Madhya Pradesh.jpg";

const destinations = [
  { name: "Jaipur", image: p1, state: "Rajasthan", slug: "jaipur" },
  { name: "Udaipur", image: p2, state: "Rajasthan", slug: "udaipur" },
  { name: "Goa", image: p3, state: "Goa", slug: "goa" },
  { name: "Shimla", image: p4, state: "Himachal Pradesh", slug: "shimla" },
  { name: "Leh Ladakh", image: p5, state: "Ladakh", slug: "ladakh" },
  { name: "Varanasi", image: p6, state: "Uttar Pradesh", slug: "varanasi" },
  { name: "Ayodhya", image: p7, state: "Uttar Pradesh", slug: "ayodhya" },
  { name: "Mumbai", image: p8, state: "Maharashtra", slug: "mumbai" },
  { name: "Pune", image: p9, state: "Maharashtra", slug: "pune" },
  { name: "Bangalore", image: p10, state: "Karnataka", slug: "bangalore" },
  { name: "Coorg", image: p11, state: "Karnataka", slug: "coorg" },
  { name: "Chennai", image: p12, state: "Tamil Nadu", slug: "chennai" },
  { name: "Ooty", image: p13, state: "Tamil Nadu", slug: "ooty" },
  { name: "Hyderabad", image: p14, state: "Telangana", slug: "hyderabad" },
  { name: "Kolkata", image: p15, state: "West Bengal", slug: "kolkata" },
  { name: "Darjeeling", image: p16, state: "West Bengal", slug: "darjeeling" },
  { name: "Kochi", image: p17, state: "Kerala", slug: "kochi" },
  { name: "Munnar", image: p18, state: "Kerala", slug: "munnar" },
  { name: "Ahmedabad", image: p19, state: "Gujarat", slug: "ahmedabad" },
  { name: "Dwarka", image: p20, state: "Gujarat", slug: "dwarka" },
  { name: "Bhopal", image: p21, state: "Madhya Pradesh", slug: "bhopal" },
  { name: "Khajuraho", image: p22, state: "Madhya Pradesh", slug: "khajuraho" },
];

const Destinations = () => {

  // ✅ UPDATED STRUCTURED DATA (.com FIX)
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Top Road Trip Destinations in India",
    "description": "A list of the best travel destinations in India for self-drive car rentals.",
    "itemListElement": destinations.map((dest, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "name": dest.name,
      "url": `https://www.shreeramcarrental.com/destinations#${dest.slug}` // ✅ FIXED
    }))
  };

  return (
    <>
      <Helmet>
        <title>20+ Best Road Trip Destinations in India | Shree Ram Car Rental</title>

        <meta 
          name="description" 
          content="Explore India's top travel destinations like Jaipur, Ayodhya, and Goa. Rent a self-drive car from Indore and drive to these beautiful locations with ease." 
        />

        <meta 
          name="keywords" 
          content="self drive car destinations, road trips from indore, Jaipur car rental, Goa trip by car, Ayodhya travel, car hire for outstation" 
        />

        {/* ✅ CANONICAL (VERY IMPORTANT) */}
        <link rel="canonical" href="https://www.shreeramcarrental.com/destinations" />

        {/* ✅ SCHEMA */}
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <main className="dest-page">
        <div className="dest-container">
          <header className="dest-header">
            <span className="dest-tag">Where to go?</span>
            <h1 className="dest-title">
              Car Rental Destinations <span>in India</span>
            </h1>
            <p className="dest-subtitle">
              Planning a long-distance road trip? Here are the top-rated cities 
              visited by <strong>Shree Ram Car Rental</strong> customers across India.
            </p>
          </header>

          <section className="dest-grid-wrapper">
            <ul className="dest-grid">
              {destinations.map((place, index) => (
                <li className="dest-item" key={index} id={place.slug}>
                  <article className="dest-card">
                    <div className="dest-image-wrapper">
                      <img 
                        src={place.image} 
                        alt={`Car rental and travel guide for ${place.name}, ${place.state}`} 
                        title={`Travel to ${place.name} with Shree Ram Car Rental`}
                        loading="lazy"
                      />
                      <div className="dest-badge">Outstation</div>
                    </div>
                    <div className="dest-info">
                      <h2 className="dest-name">{place.name}</h2>
                      <p className="dest-state">
                        📍 {place.state}
                      </p>
                    </div>
                  </article>
                </li>
              ))}
            </ul>
          </section>
        </div>
      </main>
    </>
  );
};

export default Destinations;